import { MARQUEE_ITEMS } from "../constants/site";

const Row = ({ ariaHidden = false }) => (
    <div
        aria-hidden={ariaHidden}
        className="flex w-max shrink-0 items-center gap-10 pr-10"
    >
        {MARQUEE_ITEMS.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-display text-lg font-extrabold uppercase tracking-wide text-white/75 md:text-xl">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 rounded-[2px] bg-[#E50914] shadow-[0_0_12px_rgba(229,9,20,0.8)]" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <section
        className="overflow-hidden border-y border-[#222232] bg-[#0E0E14] py-6"
        data-testid="marquee-section"
    >
        <div className="marquee-track flex w-max animate-marquee">
            <Row />
            <Row ariaHidden />
        </div>
    </section>
);
